<template>
    <div>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/1.1.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">设计和研发能力</h3>
                        <p class="swiper-p p YaSiRegular">
                            全球化团队-丹麦意大利美国阶段式工艺结构全数字3D设计与工程研发
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/1.2.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">设计和研发能力</h3>
                        <p class="swiper-p p YaSiRegular">
                            全球化团队-丹麦意大利美国阶段式工艺结构全数字3D设计与工程研发
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">高端工艺</h3>
                        <p class="swiper-p p YaSiRegular">
                            将工程工艺转化为工业工艺稳定工匠 超半数10年以上工龄
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/2.1.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">高端工艺</h3>
                        <p class="swiper-p p YaSiRegular">
                            将工程工艺转化为工业工艺稳定工匠 超半数10年以上工龄
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/2.2.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/3.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">灵活交付</h3>
                        <p class="swiper-p p YaSiRegular">
                            通过整合交付时间缩短至2周成熟的国际供应链长达25年家居行业经验
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">品质思考</h3>
                        <p class="swiper-p p YaSiRegular">
                            生产线实行领导责任制管理行业领先的检测实验室和认证
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/4.1.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">品质思考</h3>
                        <p class="swiper-p p YaSiRegular">
                            生产线实行领导责任制管理行业领先的检测实验室和认证
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/4.2.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">品质思考</h3>
                        <p class="swiper-p p YaSiRegular">
                            生产线实行领导责任制管理行业领先的检测实验室和认证
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/4.3.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/5.1.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">先进智造</h3>
                        <p class="swiper-p p YaSiRegular">
                            数字化智能转换自动化制造生产线业务流程优化
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/5.2.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">先进智造</h3>
                        <p class="swiper-p p YaSiRegular">
                            数字化智能转换自动化制造生产线业务流程优化
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/5.3.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title YaSiRegular">先进智造</h3>
                        <p class="swiper-p p YaSiRegular">
                            数字化智能转换自动化制造生产线业务流程优化
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    export default {
        name: 'CompetenciesBanner',
        data() {
            return {
                swiperOptions1: {
                    pagination: '.swiper-pagination-1',
                    paginationClickable :true,
                    autoplayDisableOnInteraction : false,
                    loop: true,
                    autoplay : 3000,
                    speed: 1000,
                    effect : 'fade',
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'styles/common' as *;
    .swiper-box {
        margin: 10vw 0 0 0;
    }
    .slide {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40%;
        background: #f4f3ee;
        @include respond-to() {
            display: block;
            width: 100%;
        }
    }
    .swiper-title {
        margin-bottom: 2vw;
        @include respond-to() {
            font-size: 1.85rem;
        }
    }
    .slide-inner {
        width:80%;
        @include respond-to() {
            padding: 10vw;
            width: 100%;
            box-sizing: border-box;
        }
    }
    .swiper-img {
        width: 60%;
        @include respond-to() {
            width: 100%;
        }
    }
    .swiper-img img {
        width: 100%;
    }
    .swiper-container-fade .swiper-slide{
        opacity:0!important;
        display: flex;
        @include respond-to() {
            display: block;
        }
    }
    .swiper-container-fade .swiper-slide-active{opacity:1!important;}
</style>
